import { apiRequest } from '../../../../shared/api/index.js';

export const deletePayment = async (id: string): Promise<void> => {
  await apiRequest<void>(`/payments/${id}`, { method: 'DELETE' });
};
